module.exports = __webpack_public_path__ + "img/share_search.756cd8ad.png";